import { CheckboxStore } from '../../../../../stores/CheckboxStore'
import NewPaginationStore from '../../../../../stores/NewPaginationStore'
import RequestsTableFilterStore from '../stores/RequestsTableFilterStore'
import { RequestTableParamsType } from '../types/new-requests-table.types'

const assignInitParams: RequestTableParamsType = {
  'preset.statuses': [2],
}
const acceptedInitParams: RequestTableParamsType = {
  'preset.statuses': [4],
}
const processInitParams: RequestTableParamsType = {
  'preset.statuses': [11],
}
const workingInitParams: RequestTableParamsType = {
  'preset.statuses': [5],
}

const completeInitParams: RequestTableParamsType = {
  'preset.statuses': [6, 12, 13, 14, 15, 16],
}

const refusedInitParams: RequestTableParamsType = {
  'preset.statuses': [7],
}

export const allDealerPaginationStore = new NewPaginationStore({})
export const assignDealerPaginationStore = new NewPaginationStore(
  assignInitParams,
)
export const acceptDealerPaginationStore = new NewPaginationStore(
  acceptedInitParams,
)
export const processDealerPaginationStore = new NewPaginationStore(
  processInitParams,
)
export const workingDealerPaginationStore = new NewPaginationStore(
  workingInitParams,
)
export const completeDealerPaginationStore = new NewPaginationStore(
  completeInitParams,
)
export const refusedDealerPaginationStore = new NewPaginationStore(
  refusedInitParams,
)

export const allDealerFiltersStore = new RequestsTableFilterStore()
export const assignDealerFiltersStore = new RequestsTableFilterStore()
export const acceptDealerFiltersStore = new RequestsTableFilterStore()
export const processDealerFiltersStore = new RequestsTableFilterStore()
export const workingDealerFiltersStore = new RequestsTableFilterStore()
export const completeDealerFiltersStore = new RequestsTableFilterStore()
export const refusedDealerFiltersStore = new RequestsTableFilterStore()

export const allDealerCheckboxStore = new CheckboxStore()
export const assignDealerCheckboxStore = new CheckboxStore()
export const acceptDealerCheckboxStore = new CheckboxStore()
export const processDealerCheckboxStore = new CheckboxStore()
export const workingDealerCheckboxStore = new CheckboxStore()
export const completeDealerCheckboxStore = new CheckboxStore()
export const refusedDealerCheckboxStore = new CheckboxStore()

export const tabComponents = {
  'все заявки': {
    paginationStore: allDealerPaginationStore,
    filtersStore: allDealerFiltersStore,
    checkboxStore: allDealerCheckboxStore,
  },
  назначены: {
    paginationStore: assignDealerPaginationStore,
    filtersStore: assignDealerFiltersStore,
    checkboxStore: assignDealerCheckboxStore,
  },
  приняты: {
    paginationStore: acceptDealerPaginationStore,
    filtersStore: acceptDealerFiltersStore,
    checkboxStore: acceptDealerCheckboxStore,
  },
  'в работе': {
    paginationStore: processDealerPaginationStore,
    filtersStore: processDealerFiltersStore,
    checkboxStore: processDealerCheckboxStore,
  },
  установка: {
    paginationStore: workingDealerPaginationStore,
    filtersStore: workingDealerFiltersStore,
    checkboxStore: workingDealerCheckboxStore,
  },
  установленные: {
    paginationStore: completeDealerPaginationStore,
    filtersStore: completeDealerFiltersStore,
    checkboxStore: completeDealerCheckboxStore,
  },
  'не выполненные': {
    paginationStore: refusedDealerPaginationStore,
    filtersStore: refusedDealerFiltersStore,
    checkboxStore: refusedDealerCheckboxStore,
  },
}

export const resetAllAdminFiltersAndPagination = () => {
  allDealerPaginationStore.resetParams()
  allDealerPaginationStore.resetSelectedRow()
  allDealerCheckboxStore.resetAll(true)
  allDealerFiltersStore.clear()

  assignDealerPaginationStore.resetParams()
  assignDealerPaginationStore.resetSelectedRow()
  assignDealerCheckboxStore.resetAll(true)
  assignDealerFiltersStore.clear()

  acceptDealerPaginationStore.resetParams()
  acceptDealerPaginationStore.resetSelectedRow()
  acceptDealerCheckboxStore.resetAll(true)
  acceptDealerFiltersStore.clear()

  processDealerPaginationStore.resetParams()
  processDealerPaginationStore.resetSelectedRow()
  processDealerCheckboxStore.resetAll(true)
  processDealerFiltersStore.clear()

  workingDealerPaginationStore.resetParams()
  workingDealerPaginationStore.resetSelectedRow()
  workingDealerCheckboxStore.resetAll(true)
  workingDealerFiltersStore.clear()

  completeDealerPaginationStore.resetParams()
  completeDealerPaginationStore.resetSelectedRow()
  completeDealerCheckboxStore.resetAll(true)
  completeDealerFiltersStore.clear()

  refusedDealerPaginationStore.resetParams()
  refusedDealerPaginationStore.resetSelectedRow()
  refusedDealerCheckboxStore.resetAll(true)
  refusedDealerFiltersStore.clear()
}
